import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
} from "../../api/authenticatedFetch";

const BASE_API = "/api/v1";

export const getEnforcementOverview = async () => {
  const data = await authenticatedGet(`${BASE_API}/budget-enforcement/overview`);
  return data?.overview ?? {};
};

export const listBudgetPolicies = async () => {
  const data = await authenticatedGet(`${BASE_API}/budget-policies`);
  return data?.policies ?? [];
};

export const getBudgetPolicy = async (id) => {
  const data = await authenticatedGet(`${BASE_API}/budget-policies/${id}`);
  return data?.policy ?? null;
};

export const createBudgetPolicy = async (payload) => {
  const data = await authenticatedPost(`${BASE_API}/budget-policies`, payload);
  return data?.policy ?? null;
};

export const updateBudgetPolicy = async (id, payload) => {
  const data = await authenticatedPut(`${BASE_API}/budget-policies/${id}`, payload);
  return data?.policy ?? null;
};
